module.exports = __webpack_public_path__ + "img/video.00dc7bea.svg";